import React, {Component} from 'react';
import {InputItem, Checkbox, Modal, Popover, Toast} from 'antd-mobile';
import "./style.less";
import {addOften} from "../../service/memberService";
const CheckboxItem = Checkbox.CheckboxItem;
const Item = Popover.Item;
export default class SpecialPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selPsgModal:false,
            name:'',
            sfzVal:'',
            phone:'',
            numVisible: false,
            numSelected: '身份证',
            passport:[
                {
                    "value":"身份证",
                    "desription":"身份证"
                },
                {
                    "value":"护照",
                    "desription":"护照"
                },
                {
                    "value":"边民证",
                    "desription":"边民证"
                }
            ],
        };
    }
    showDiscount(i,index){
        if(i.deductionPic > 0 || i.discount > 0){
            return(
                <div className="discount">
                    <div className="integralBox">
                        <div>
                            <div className="pic">-￥{i.deductionPic}</div>
                            <div className="">积分</div>
                        </div>
                        <CheckboxItem key={index} onChange={(e) => this.props.checkChange(i,e)}  checked={i.checkBox}/>
                    </div>
                    <div className="coupon" onClick={()=>this.props.openDiscount(i)}>
                        <div>
                            <div  className={i.isChild == 1 ? "pic line" : "pic"}>-￥{i.discount}</div>
                            <div className={i.isChild == 1 ? "line" : null}>优惠券</div>
                        </div>
                        <i className="icon iconfont icontiaozhuan"/>
                    </div>
                </div>
            )
        }
    }
    inpChange= key => (value)=>{
        this.setState({[key]:value})
    };
    show_sub(e){
        this.setState({numSelected:e.target.value})
    }
    addPassenger=()=>{
        if (this.state.name === '') {
            Toast.info('请填写姓名');
            return
        }
        if(this.state.sfzVal === '' ){
            Toast.info('请填写证件号');
            return
        }
        if(this.state.sfzVal.length < 5 ){
            Toast.info('证件号码不能少于5位');
            return
        }
        if(this.state.phone === ''){
            Toast.info('请填写联系电话');
            return
        }
        Toast.loading('',0);
        let params = {
            token: this.props.userInfo.token,
            source:1,
            data:{
                name:this.state.name,
                phone:this.state.phone,
                idNum:this.state.sfzVal,
                idType:this.state.numSelected == "身份证" ? "idcard":this.state.numSelected == "护照" ? "passport" : "borderCard",
            },
        };
        console.log(params)
        addOften(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.info("添加成功",2,()=> {
                    this.setState({selPsgModal:false});
                    this.props.selPagOk(res.data.data);
                });
            } else {
                Toast.info(res.data.msg,3);
            }
        }).catch(function (error) {
            console.log(error);
        });
    };
    render(){
        const props = this.props.location.state;
        const {seatData}=this.props;
        return(
            <div className="contentTop contents">
                <div className="topBar">
                    <div className="top">
                        <div className="yuyue">预约车辆：<span>{seatData.carNum}</span></div>
                        <div className="info">可约 <span className="num">{ props.remainingSeat + '人'}</span></div>
                        {/* <div className="info"><span className="car">{seatData.carNum} </span>可约 <span className="num">{ props.remainingSeat + '人'}</span></div> */}
                    </div>
                    <div className="address">
                        <div>
                            <i className="icon iconfont icontime" />
                            <span>{seatData.date} <span className="times">{seatData.pickUpTime + "~" + seatData.startTime}</span></span>
                        </div>
                        <div>
                            <i className="icon iconfont iconchufa" />
                            <span>{seatData.startCity} <span  className="addressText">{props.startAddress}</span></span>
                        </div>
                        <div>
                            <i className="icon iconfont icondaoda" />
                            <span>{seatData.endCity} <span  className="addressText">{props.endAddress}</span></span>
                        </div>
                    </div>
                </div>
                {
                    this.props.seatData.isBaby == 0 ? (
                        <div className="setBaby" >
                            <div>
                                <i className="icon iconfont iconertong"/>
                                <span  className='title'>儿童订单</span>
                                <span>一车仅限一位儿童</span>
                            </div>
                            <CheckboxItem  onChange={(e) => this.props.babyChange(e)} checked={this.props.babyVal}>
                            </CheckboxItem>
                        </div>
                    ): <div className="setBaby" >如有儿童(含婴幼儿)乘车请联系客服，当前儿童订单已售罄。</div>
                }
                {
                    this.props.integralList.map((i,index)=>(
                        <div className="passenger" key={index}>
                            <div className="userBox">
                                <div  className="name">{i.contactsName} {i.isChild == 1 ? <span className="child">儿童票</span> : null}</div>
                                <div  className="num">{i.contactsIdNum}</div>
                                <div  className="delete" onClick={()=>this.props.selSeat(index,i)}>删除</div>
                            </div>
                            {this.showDiscount(i,index)}

                        </div>

                    ))
                }

                <div className="addUser" onClick={()=>{
                    this.setState({
                        name:"",
                        sfzVal:"",
                        phone:"",
                    });
                    this.props.getOftenList();
                    this.setState({selPsgModal:true})
                }}>
                    <i  className="icon iconfont icontianjiala" /> 添加/选择乘车人
                </div>

                <Modal
                    className="selPsgModal seatPsgModal"
                    // animationType="slide-up"
                    popup
                    maskClosable={false}
                    visible={this.state.selPsgModal}
                    onClose={()=>this.setState({selPsgModal:false})}
                >
                    <div className="content">
                        <div className="top">
                            <div onClick={()=>this.setState({selPsgModal:false})}>取消</div>
                            <div style={{"paddingRight":"20px"}}>选择乘客</div>
                            <div></div>
                        </div>
                        <div className="box">
                            <p>乘客信息为实际乘车人，为了保障您的权益请如实填写</p>
                            <div className="addPsg" >
                                <InputItem
                                    placeholder="请输入姓名"
                                    clear
                                    value={this.state.name}
                                    onChange={this.inpChange('name')}
                                    type="text"
                                >姓名</InputItem>
                                <InputItem
                                    placeholder={"请输入"+this.state.numSelected}
                                    clear
                                    value={this.state.sfzVal}
                                    onChange={this.inpChange('sfzVal')}
                                    maxLength={18}
                                    onBlur={v => window.scroll(0,0)}
                                >
                                    <select value={this.state.numSelected} onChange={(v)=>this.show_sub(v)}>
                                        {this.state.passport.map((res,i)=>(
                                            <option key={i} value={res.value}>{res.desription}</option>
                                        ))}
                                    </select>
                                    <i className="icon iconfont iconxiala"/>
                                </InputItem>
                                <InputItem
                                    placeholder="请输入联系电话"
                                    clear
                                    value={this.state.phone}
                                    onChange={this.inpChange('phone')}
                                    type="number"
                                >联系电话</InputItem>

                            </div>
                            <button  onClick={this.addPassenger}>添加</button>
                            <div className="itemBox">
                                {
                                    this.props.psgData == "" ?  <div>暂无常用乘车人</div> : (
                                        this.props.psgData.map((res,i) => (
                                                <div className="item"  key={i} onClick={()=>{
                                                    this.setState({selPsgModal:false});
                                                    this.props.selPagOk(res);
                                                }}>
                                                    <div className="info">
                                                        <span>{res.name}</span>
                                                        <div className="">{res.numSelected} &nbsp;&nbsp;{res.idNum}</div>
                                                    </div>
                                                    <i  className="icon iconfont icontianjiala" />
                                                </div>
                                            )
                                        ))
                                }
                            </div>

                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SpecialPage/index.js